export default __webpack_public_path__ + "static/media/Armbands of Vindictive Malice.cf5dd3a0.jpg";